import { useMemo } from 'react';
import { useCarEBoxLocations, useCarOperations } from 'entities/cars';

import {
  getCarNumberIcon
} from '../utils/carNumberIcon';

import { HereLayer } from 'common/utils/MapMarker/types';
import { CarEBoxLocation } from 'entities/cars';

import { EMPTY_ARRAY } from 'shared/constants';
import { CAR_HEIGHT } from 'components/Map/constants';

export const useCarNumberMarkersLayer = () => {
  const autosCoordinates = useCarEBoxLocations();
  const { setSelectedCarEBoxLocation } = useCarOperations();

  const сarNumberMarkersLayer = useMemo((): HereLayer => ({
    data: autosCoordinates || EMPTY_ARRAY as any,
    name: 'cars-number-title',
    type: 'marker',
    getCoordinates: ({
      data: {
        latitude,
        longitude
      }
    }) => ({
      latitude,
      longitude
    }),
    getIcon: ({ data = {} }) => {
      const {
        url,
        height,
        width
      } = getCarNumberIcon({
        properties: {
          cluster: false,
          ...data
        }
      });

      return ({
        url,
        height,
        width,
        anchorY: CAR_HEIGHT + height + 5,
        anchorX: width / 2,
        id: data.autoNumber
      });
    },
    onClick: ({ data }: any) => {
      setSelectedCarEBoxLocation(data as CarEBoxLocation);
    }
  }), [
    autosCoordinates,
    setSelectedCarEBoxLocation
  ]);

  return сarNumberMarkersLayer;
};